var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92207 3.71895L7.5002 16.9455C7.69551 17.5158 8.50801 17.5002 8.6877 16.9221L10.5314 10.9377C10.5593 10.8399 10.6121 10.751 10.6847 10.6797C10.7573 10.6085 10.8472 10.5574 10.9455 10.5314L16.9221 8.6877C17.5002 8.50801 17.5158 7.69551 16.9455 7.5002L3.71895 2.92207C3.60782 2.88302 3.48792 2.87616 3.37306 2.90229C3.2582 2.92843 3.15307 2.98649 3.06978 3.06978C2.98649 3.15307 2.92843 3.2582 2.90229 3.37306C2.87616 3.48792 2.88302 3.60782 2.92207 3.71895V3.71895Z",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationArrow);
export default __webpack_public_path__ + "static/media/navigation-arrow.89b2099f717c1dd24572bec9e35d6698.svg";
export { ForwardRef as ReactComponent };